import { getAuthState } from "./auth/authStore";
import { initializeHttpClient } from "./http/client";

interface HallticketLibOptions {
  apiBaseURL: string;
  refreshToken?: () => Promise<string | null>;
}

export function initializeHallticketLib(options: HallticketLibOptions): void {
  initializeHttpClient({
    baseURL: options.apiBaseURL,
    getToken: () => getAuthState().firebaseIdToken,
    refreshToken: options.refreshToken,
  });
}

export * from "./auth/types";
export * from "./auth/authStore";
export * from "./auth/authService";
export * from "./users/userService";
export * from "./results/hapService";
export * from "./results/resultPreviewService";
export * from "./courses/preferredCoursesApi";
export * from "./colleges/collegesService";
export * from "./exporter/spotTickerService";
export * from "./exporter/spotCollegesService";
export * from "./spot/spotViewerService";
export * from "./spot/spotRoundSort";
export * from "./reference/referenceDataService";
export * from "./reference/reservationTypeService";
export * from "./http/client";
export * from "./react/useAuthState";
export * from "./react/useSubscriptionState";
export * from "./subscription/types";
export * from "./subscription/subscriptionStore";
export * from "./subscription/subscriptionService";
export * from "./try-now/tryNowJourney";
